module.exports = __webpack_public_path__ + "img/assuraf_lg.cda68d3e.png";